<template>
  <div class="product-display" :class="colorClass">
    <h2 class="heading">{{ title }}</h2>
    <p class="sub-heading">
      {{ subTitle }}
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ProductDisplay",
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "white",
      validator: function (value) {
        return ["grey", "black", "white"].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    colorClass() {
      return {
        "product-display--grey": this.color === "grey",
        "product-display--black": this.color === "black",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.product-display {
  background: $color-white;
  padding: 60px 0;
  @include respond-above(md) {
    padding: 80px 0;
  }
  &--grey {
    background: $color-grey-lightest;
    .heading,
    .sub-heading {
      color: $color-black;
    }
  }
  &--black {
    background: $color-black;
    .heading,
    .sub-heading {
      color: $color-white;
    }
  }
}

.heading {
  color: $color-black;
  @include editorial-headline(24px);
  margin-bottom: 10px;
  padding: 0 20px;
  text-transform: initial;

  @include respond-above(md) {
    @include editorial-headline(40px);
    text-align: center;
    margin-bottom: 8px;
  }
}

.sub-heading {
  color: $color-black;
  padding: 0 20px;
  margin-bottom: 10px;
  @include utility-body(12px);
  @include respond-above(md) {
    @include utility-body(14px);
    text-align: center;
    margin-bottom: 30px;
  }
}
</style>
